// extracted by mini-css-extract-plugin
module.exports = {"recipient_Number":"tableBulkEmails_recipient_Number__2xuIK"};